import { render, staticRenderFns } from "./documentPop.vue?vue&type=template&id=eef8ff66"
import script from "./documentPop.vue?vue&type=script&lang=js"
export * from "./documentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eef8ff66')) {
      api.createRecord('eef8ff66', component.options)
    } else {
      api.reload('eef8ff66', component.options)
    }
    module.hot.accept("./documentPop.vue?vue&type=template&id=eef8ff66", function () {
      api.rerender('eef8ff66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/psi/documentPop.vue"
export default component.exports